import {init as DicomImageLoaderInit, wadouri} from "@cornerstonejs/dicom-image-loader"
import {init as CoreInit, RenderingEngine, Enums as cEnums, imageLoader, metaData} from "@cornerstonejs/core"
import {init as ToolsInit, segmentation as ToolsSegmentation, ToolGroupManager, Enums as tEnums} from "@cornerstonejs/tools"
import { adaptersSEG } from "@cornerstonejs/adapters";
import addManipulationBindings from "./helpers/addManipulationBindings.js";
import labelmapTools from "./helpers/labelmapTools.js";

export const c3dState = {
    initialized: false,
    renderingEngineId: "myRenderingEngine",
    renderingEngine: null,
    viewportId: "CT",
    viewport: null,
    toolGroupId: "myToolGroup",
    toolGroup: null,
};

export async function setup(element) {
    console.warn('----------> Initializing Cornerstone3D...');
    console.log("with ", c3dState.toolGroupId, c3dState.renderingEngineId, c3dState.viewportId)

    // only initialize once
    if (!c3dState.initialized) {

        // initialize cornerstone
        CoreInit()
        ToolsInit()
        DicomImageLoaderInit({ maxWebWorkers: 1 })

        // tool group
        const toolGroup = ToolGroupManager.createToolGroup(
            c3dState.toolGroupId
        );

        addManipulationBindings(toolGroup, {
            toolMap: labelmapTools.toolMap
        });

        // rendering engine
        const renderingEngine = new RenderingEngine(
            c3dState.renderingEngineId
        );

        c3dState.initialized = true;
        c3dState.toolGroup = toolGroup;
        c3dState.renderingEngine = renderingEngine;
    }

    
    // viewport
    const viewportInput = {
        viewportId: c3dState.viewportId,
        type: cEnums.ViewportType.STACK,
        element,
        defaultOptions: {
            orientation: cEnums.OrientationAxis.SAGITTAL,
        },
    }

    c3dState.renderingEngine.enableElement(viewportInput)

    const viewport = c3dState.renderingEngine.getStackViewport(
        c3dState.viewportId
    );
    
    // (in example, this is run when dicom is loaded ..)
    c3dState.toolGroup.addViewport(
        c3dState.viewportId, 
        c3dState.renderingEngineId
    );

    // update state
    c3dState.viewport = viewport;
}

export async function renderDicomImage(files) {
    
    //
    if (!c3dState.initialized) {
        console.error('Cornerstone3D not initialized yet, skipping renderDicomImage');
        return;
    }

    //
    const imageIds = [];
    for (const file of files) {
        const imageId = wadouri.fileManager.add(file);
        await imageLoader.loadAndCacheImage(imageId);
        imageIds.push(imageId);
    }

    //
    c3dState.viewport.setStack(imageIds);
    c3dState.renderingEngine.render();
}

export async function renderDicomSegmentation(file, segmentationId = "mySegmentationId") {

    //
    if (!c3dState.initialized) {
        console.error('Cornerstone3D not initialized yet, skipping renderDicomSegmentation');
        return;
    }

    // remove segmentations if they already exist
    ToolsSegmentation.removeAllSegmentationRepresentations();
    
    const segmentationIds = ToolsSegmentation.state.getSegmentations().map(x => x.segmentationId);

    if (segmentationIds.length) {
        console.log("remove existing segmentations", segmentationIds)
        segmentationIds.forEach(segmentationId => {
            ToolsSegmentation.state.removeSegmentation(segmentationId);
            // cache.removeVolumeLoadObject(segmentationId);
        });
    }

    //
    const imageId = wadouri.fileManager.add(file);
    const image = await imageLoader.loadAndCacheImage(imageId);

    if (!image) {
        console.error('Failed to load image from file:', file);
        return;
    }

    const instance = metaData.get("instance", imageId);
    console.log('Instance metadata:', instance);
    console.log('instance modality:', instance.Modality);

    if (instance.Modality !== 'SEG') {
        console.error('Image is not a segmentation, skipping renderDicomSegmentation');
        return;
    }

    const arrayBuffer = image.data.byteArray.buffer;
    console.log('ArrayBuffer loaded:', arrayBuffer);

    const referenceImageIds = c3dState.viewport.getImageIds();
    console.log('Reference Image IDs:', referenceImageIds);

    const { labelMapImages } = await adaptersSEG.Cornerstone3D.Segmentation.createFromDICOMSegBuffer(
        referenceImageIds,
        arrayBuffer,
        {
            metadataProvider: metaData
        }
    );

    console.log('Label map images:', labelMapImages);
    const imageIds = labelMapImages?.flat().map(image => image.imageId);
    console.log('Image IDs for segmentation:', segmentationId, imageIds);
    ToolsSegmentation.addSegmentations([
        {
            segmentationId,
            representation: {
                type: tEnums.SegmentationRepresentations.Labelmap,
                data: {
                    imageIds
                }
            }
        }
    ]);

    console.log('Adding labelmap representation to viewport:', c3dState.viewportId, segmentationId);
    ToolsSegmentation.addLabelmapRepresentationToViewport(c3dState.viewportId, [
        {
            segmentationId,
            config: {}
        }
    ]);

    console.log('Rendering viewport with segmentation:', c3dState.viewportId);
    c3dState.viewport.render();
}
